import React, { useEffect } from "react";
import {
  Drawer,
  DrawerClose,
  DrawerContent,
  DrawerDescription,
  DrawerFooter,
  DrawerHeader,
  DrawerTitle,
} from "@/components/ui/drawer";
import ProductCard from "./ui-sdk/components/product-card";
import {
  Carousel,
  CarouselContent,
  CarouselItem,
} from "./components/ui/carousel";

export function SimilarDrawer({
  list,
  loading,
}: {
  list: any[];
  loading: boolean;
}) {
  const [open, setOpen] = React.useState(true);
  useEffect(() => {
    setOpen(true);
  }, [list]);
  return (
    <Drawer
      open={open}
      onOpenChange={(bool) => {
        if (!bool) setOpen(false);
      }}
    >
      <DrawerContent>
        <DrawerHeader>
          <DrawerTitle>Similar Products</DrawerTitle>
        </DrawerHeader>
        {loading && <ProductCardLoader />}
        <ul className="swimlane2 no-scrollbar hp-flex hp-w-full hp-place-items-center hp-pl-0">
          {!loading &&
            list.map((item, key) => (
              <ProductCard
                className="w-[200px] min-w-[200px]"
                key={item.id}
                product={item}
              />
            ))}
        </ul>
        {!loading && list.length === 0 && (
          <div className="hp-px-4 hp-text-center">
            No similar products found
          </div>
        )}
        <DrawerFooter>
          <DrawerClose></DrawerClose>
        </DrawerFooter>
      </DrawerContent>
    </Drawer>
  );
}

function ProductCardLoader() {
  return (
    <div className="hp-flex hp-w-full hp-flex-row hp-gap-2 hp-overflow-hidden hp-px-4">
      {new Array(4).fill(0).map((_, i) => (
        <div className="hp-shimmer hp-h-48 hp-w-48 hp-bg-gray-200" key={i} />
      ))}
    </div>
  );
}
